<template>
	<div class="guizhou-driver">
		<header class="gd-header">
			<!-- 页面头部 -->
			<div class="all-title flex justify-center align-center">
				<div class="img-bg">
					<div class="flex justify-center align-center">
						<!-- <div class="flex justify-end align-center text-xs leftBox"></div> -->
						<div class="bigtitle flex align-center justify-center text-xxl">
							交通驾驶舱管理平台
						</div>
						<!-- <div class="rightBox flex justify-start align-center text-xs"></div> -->
					</div>
				</div>
			</div>
		</header>
		<div class="flex gd-content">
			<div class="left-content">
				<!-- <div class="left-content-title">每隔一小时数据更新一次</div> -->
				<div class="car-data">
					<div class="car-data-title content-box-title">车辆数据</div>
					<div class="car-data-info flex">
						<div class="indicator">
							<img class="bg" src="@/assets/images/index/indicators_icon.png" />
							<div>
								<p class="counts">{{ vehicleTotalOnlineData.sl }}</p>
								<p class="text">车辆总量</p>
							</div>
						</div>
						<div class="indicator">
							<img class="bg" src="@/assets/images/index/indicators_icon.png" />
							<div>
								<p class="counts">{{ vehicleTotalOnlineData.vehicle_vin }}</p>
								<p class="text">本月新入网</p>
							</div>
						</div>
						<div class="indicator">
							<img class="bg" src="@/assets/images/index/indicators_icon.png" />
							<div>
								<p class="counts">{{ vehicleTotalOnlineData.onlinesl }}</p>
								<p class="text">上线车辆</p>
							</div>
						</div>
						<div class="indicator">
							<img class="bg" src="@/assets/images/index/indicators_icon.png" />
							<div>
								<p class="counts">{{ vehicleTotalOnlineData.offlinesl }}</p>
								<p class="text">离线车辆</p>
							</div>
						</div>
					</div>
				</div>
				<div class="alarms-data">
					<div class="content-box-title">近7天累计行驶时长</div>
					<div class="alarms-e-chart" ref="alarmsEChart"></div>
				</div>
				<div class="active-data">
					<div class="content-box-title">近7日日活车辆数</div>
					<div class="active-e-chart" ref="activeEChart"></div>
				</div>
			</div>
			<div class="center-content">
				<div class="my-map" ref="mapEChart"></div>
			</div>
			<div class="right-content">
				<div class="mileage-box">
					<div class="content-box-title">里程数据</div>
					<div class="mileage-item">
						昨日总里程数：<span>{{ mileageData.run_mileage }}</span
						>公里
					</div>
					<div class="mileage-item">
						本年总里程数：<span>{{ mileageData.year_run_mileage }}</span
						>公里
					</div>
				</div>
				<div class="pie-chart-box">
					<div class="content-box-title">车辆性能</div>
					<div class="battery-pie" ref="batteryPieChart"></div>
					<div class="speed-pie" ref="speedPieChart"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import guizhouMap from '@/utils/guizhouMap'
import echarts from 'echarts'
import { dataInterface } from '@/api/dataInterfaceApi'

export default {
	components: {},
	props: {},
	data() {
		return {
			mapEChart: null,
			alarmsEChart: null,
			batteryPieChart: null, // 电量饼图
			speedPieChart: null, // 车速饼图
			activeEChart: null, // 活跃图
			vehicleTotalOnlineData: {
				sl: '',
				onlinesl: '',
				offlinesl: '',
				vehicle_vin: '',
			},
			mileageData: {
				run_mileage: '', // 前日总里程数
				year_run_mileage: '', // 本年总里程数
			},
		}
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		// document.querySelector('body').setAttribute('style', 'background: none;')
		this.initChart()
		this.fetchVehicleTotalOnline()
		this.fetchMileage()
	},
	methods: {
		initChart() {
			this.initMap()
			this.initAlarms()
			this.initBatteryPie()
			this.initSpeedPie()
			this.initActiveEChart()
		},
		async initMap() {
			const res = await dataInterface.fetchDataInterface(
				'63abf0568cb24e3285b1880d23476362'
			)
			// echarts.registerMap('中国', guizhouMap)
			this.mapEChart = echarts.init(this.$refs.mapEChart)
			let option = {
				tooltip: {
					trigger: 'item'
				},
				title: {
					text: '',
					x: 'center',
				},
				geo: {
					map: 'china',
					label: {},
					// zlevel: 1,
					// roam: false,
					itemStyle: {
						normal: {
							borderWidth: 5,
							borderColor: "rgba(29, 111, 165,1)",
							shadowColor: "rgba(180, 180, 207)",
							shadowOffsetY: 25,
							shadowBlur: 12,
							areaColor: "rgba(5,21,35,0.1)",
						},
					},
					borderColor: {
						type: "linear",
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [
							{
								offset: 0,
								color: "#20a2e1", // 0% 处的颜色
							},
							{
								offset: 0.8,
								color: "#085473", // 80% 处的颜色
							},
							{
								offset: 1,
								color: "#054660", // 100% 处的颜色
							},
						],
					},
					areaColor: {
						type: "linear",
						x: 1200,
						y: 0,
						x2: 0,
						y2: 0,
						colorStops: [
							{
							offset: 0,
							color: "#17498d", // 0% 处的颜色
							},
							{
							offset: 1,
							color: "#3a95fd", // 50% 处的颜色
							},
						],
						global: true, // 缺省为 false
					},
				}, 
				series: [
					{
						name: '中国',
						type: 'map',
						mapType: '中国',
						// symbol: 'pin',
						label: {
							normal: {
								show: true,
								textStyle: {
									color: '#fff',
									fontSize: 18
								},
								formatter(parmas) {
									return `${parmas.name} ${parmas.value || '-'}`
								},
								emphasis: {
									show: true
								}
							}
						},
						zoom: 1, //当前视角的缩放比例
						// roam: true, //是否开启平游或缩放
						// scaleLimit: {
						// 	//滚轮缩放的极限控制
						// 	min: 1,
						// 	max: 2, //可以放大几倍
						// },
						itemStyle: {
							normal: {
								areaColor: '#87CEFB',
								borderColor: '#389dff',
								borderWidth: 5,
								shadowColor: "rgba(75, 150, 255, 0.5)",
								shadowOffsetY: 25,
								shadowBlur: 12
							},
							emphasis: {
								areaColor: '#67c23a',
								shadowOffsetX: 0,
								shadowOffsetY: 0,
								shadowBlur: 5,
								borderWidth: 0,
								shadowColor: '#fff',
							},
						},
						data: res,
						showEffectOn: 'render',
						rippleEffech: {
							brushType: 'stroke'
						},
						hoverAnimation: true
					}
				],
			}
			this.mapEChart.setOption(option)
		},
		async initAlarms() {
			// const res = await await dataInterface.fetchDataInterface(
			// 	'04b5c21113004afc80d82fffb8a2f488'
			// )

			let params = {
				enCode: "guizhou_chgtime_6month",
			};
			const res = await await dataInterface.dataFaceApi(params)
			const categories = []
			const seriesData = []
			res.forEach((item) => {
				categories.push(item.time)
				seriesData.push(item.sc)
			})
			const option = {
				tooltip: {
					trigger: 'axis'
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: categories,
					axisLabel: {
						textStyle: {
							color: 'white',
						},
					},
				},
				yAxis: {
					type: 'value',
					splitLine: {
						show: false,
					},
					axisLabel: {
						textStyle: {
							color: '#ddd',
						},
					},
				},
				series: [
					{
						data: seriesData,
						type: 'line',
						lineStyle: {
							color: '#178df0'
						},
						itemStyle:{
							normal: {
								color: '#fff',
							}
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient( 0, 0, 0, 1,
									[{ offset: 0, color: "rgba(109,182,243,0.5)" },
									{ offset: 1, color: "rgba(23,141,241,0.1)" },])
                            }
						},
					},
				],
			}
			this.alarmsEChart = echarts.init(this.$refs.alarmsEChart)
			this.alarmsEChart.setOption(option)
		},
		/**
		 * 电池状态饼图
		 */
		async initBatteryPie() {
			const res = await dataInterface.fetchDataInterface(
				'b6c1cbf9ddf544019d105a353b317469'
			)
			this.batteryPieChart = echarts.init(this.$refs.batteryPieChart)
			const option = {
				title: {
					text: '电池状态',
					subtext: '',
					x: 'left',
					y: 'center',
					textStyle: {
						color: '#ffffff',
					},
				},
				color: ['#5470c6', '#73c0de', '#265dc3', '#08aded'],
				tooltip: {
					trigger: 'item',
				},
				legend: {
					orient: 'vertical',
					x: 'right',
					y: 'bottom',
					textStyle: {
						color: '#ffffff', // 图例文字颜色
					},
				},
				series: [
					{
						name: '',
						type: 'pie',
						radius: '50%',
						data: res,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: '#ffffff',
							},
						},
					},
				],
			}
			this.batteryPieChart.setOption(option)
		},
		/**
		 * 车速数据
		 */
		async initSpeedPie() {
			const res = await dataInterface.fetchDataInterface(
				'2b5ee6ea6bbc4b03980b52cf960a2b3e'
			)
			this.speedPieChart = echarts.init(this.$refs.speedPieChart)
			const option = {
				title: {
					text: '车速数据',
					subtext: '',
					x: 'left',
					y: 'center',
					textStyle: {
						color: '#ffffff',
					},
				},
				color: ['#5470c6', '#73c0de', '#92cc76', '#76b6e1'],
				tooltip: {
					trigger: 'item',
				},
				legend: {
					orient: 'vertical',
					x: 'right',
					y: 'bottom',
					textStyle: {
						color: '#ffffff', // 图例文字颜色
					},
				},
				series: [
					{
						name: '',
						type: 'pie',
						radius: '50%',
						data: res,
					},
				],
			}
			this.speedPieChart = echarts
				.init(this.$refs.speedPieChart)
				.setOption(option)
		},
		async initActiveEChart() {
			this.activeEChart = echarts.init(this.$refs.activeEChart)
			const res = await dataInterface.fetchDataInterface(
				'0a2fa59c020d4691848f5b21f9cf6edd'
			)
			const secondRes = await dataInterface.fetchDataInterface(
				'cca15dfd02634112b17d0eaa84d334d7'
			)
			const threeRes = await dataInterface.fetchDataInterface(
				'2a6d0aefb9984b46a997582f11ce24b7'
			)
			console.log(res, secondRes, threeRes)
			const option = {
				tooltip: {
					trigger: 'axis'
				},
				xAxis: {
					type: 'category',
					data: threeRes.map((item) => item.name),
					axisLabel: {
						textStyle: {
							color: 'white',
						},
					},
				},
				yAxis: {
					type: 'value',
					splitLine: {
						show: false,
					},
					axisLabel: {
						textStyle: {
							color: 'white',
						},
					},
				},

				series: [
					{
						type: 'bar',
						// showBackground: true,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 0.5, color: '#188df0' },
								{ offset: 1, color: '#188df0' },
							]),
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#2378f7' },
									{ offset: 0.7, color: '#2378f7' },
									{ offset: 1, color: '#83bff6' },
								]),
							},
						},
						data: threeRes.map((item) => item.value),
					},
				],
			}
			this.activeEChart.setOption(option)
		},
		async fetchVehicleTotalOnline() {
			const res = await dataInterface.fetchDataInterface(
				'1429ddc3541f41c8a41d0dd1c4f1dfcb'
			)
			Object.assign(this.vehicleTotalOnlineData, res[0])
			const newRes = await dataInterface.fetchDataInterface(
				'b21877ac671147438e59748a20523308'
			)
			Object.assign(this.vehicleTotalOnlineData, newRes[0])
		},
		async fetchMileage() {
			const res = await dataInterface.fetchDataInterface(
				'4154bb3757e34553a22490a4f2a192b4'
			)
			this.mileageData.run_mileage = res[0].run_mileage
			const newRes = await dataInterface.fetchDataInterface(
				'5306b3b31cae40d4b61ae0c35f002ee7'
			)
			this.mileageData.year_run_mileage = newRes[0].run_mileage
		},
	},
}
</script>

<style scoped lang="scss">
.guizhou-driver{
	width: 100%;
	height: 100vh;
	position: relative;
	display: flex;
	flex-direction: column;
	.gd-header {
		flex-shrink: 0;
	}
	.gd-content {
		flex: 1;
		display: flex;
		// overflow: hidden;
	}
}
.flex {
	display: flex;
}
.my-map {
	width: 100%;
	height: 100%;
}
.center-content {
    // padding-left: 50px;
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
}
.alarms-e-chart {
	width: 100%;
	height: 300px;
}
.all-title {
	width: 100%;
	height: 110px;
	.img-bg {
		width: 100%;
		height: 110px;
		background: url('~@/assets/images/index/titel_png.png');
		background-size: 100% 110px;
		display: flex;
		justify-content: center;
		align-items: center;
		.leftBox {
			padding-left: 340px;
		}
		.bigtitle {
			// line-height: 110px;
			font-family: 'PuHuiTi Heavy';
		}
		.rightBox {
			width: 300px;
			margin-left: 380px;
		}
	}
}
.pie-chart-box {
	.battery-pie,
	.speed-pie {
		width: 100%;
		height: 320px;
	}
    .speed-pie {
		margin-top: 20px;
	}
}
.left-content, .right-content {
	width: 500px;
	flex-shrink: 0;
}

.left-content {
	// width: 400px;
	.left-content-title {
		font-size: 18px;
		font-weight: 500;
	}
	.car-data {
		margin-bottom: 20px;
		.car-data-info {
			flex-wrap: wrap;
			display: flex;
			.indicator {
				width: 50%;
				display: flex;
				align-items: center;
			}
			.car-data-info-item {
				.count {
					color: #ecf800;
					font-size: 20px;
					font-weight: 500;
					text-align: center;
					span {
						font-size: 14px;
					}
				}
				.count-title {
					width: 100px;
					text-align: center;
					padding: 10px 0;
					background-color: rgba(0, 30, 255, 1);
				}
				&:nth-child(2n + 2) {
					margin-left: 20px;
				}
				&:nth-child(3) {
					.count {
						color: rgba(0, 221, 255, 1);
					}
				}
				&:nth-child(4) {
					.count {
						color: rgba(0, 221, 255, 1);
					}
				}
			}
		}
	}
	.active-e-chart {
		width: 100%;
		height: 300px;
	}
}
.right-content {
    // padding-left: 100px;
	.mileage-box {
		margin-bottom: 20px;
		.content-box-title {
			margin-bottom: 20px;
		}
		.mileage-item {
			font-size: 18px;
			font-weight: 500;
			line-height: 50px;
			span {
				color: rgba(68, 255, 0, 1);
			}
		}
	}
}
.content-box-title {
	width: 100%;
	height: 35px;
	font-size: 22px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	// height:34px;
	line-height: 34px;
	display: flex;
	// align-items: center;
	background: url('~@/assets/images/index/title.png') no-repeat;
	background-size: cover;
	padding-left: 30px;
	margin-bottom: 20px;
}
.indicator {
	display: flex;
	// margin-top: 20px;
	// min-width: 200px;
	// margin-bottom:30px;
	.counts {
		font-size: 30px;
		color: #3dddff;
	}
	.text {
		font-size: 18px;
		color: #ffffff;
	}
}
.bg {
	width: 84px;
	height: 60px;
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
	.left-content, .right-content {
		width: 300px;
		flex-shrink: 0;

		.active-e-chart {
			height: 200px;
		}
		.mileage-box {
			.mileage-item {
				font-size: 12px;
				line-height: 30px;
			}
		}
	}
	.bg {
		width: 42px;
		height: 30px;
		font-size: 14px;
	}
	.indicator {
		.counts {
			font-size: 20px;
		}
		.text {
			font-size: 12px;
		}
	}
	.alarms-e-chart {
		height: 200px;
	}
	.pie-chart-box {
		.battery-pie,
		.speed-pie {
			height: 220px;
		}
	}
	.content-box-title {
		font-size: 14px;
		margin-bottom: 10px;
	}
	.text-xxl {
		font-size: 24px;
	}
}
</style>
